import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";
import clsx from "clsx";

export interface Opponent {
    id: number;
    name: string;
}

export default function Opponents({ opponents: { data: opponents } }: { opponents: { data: Opponent[] } }) {

    const thClasses = "font-medium px-4 py-2 text-gray-500";
    const tdClasses = "border-t border-gray-200 px-4 py-2";

    return (
        <App>
            <PageTitle title="Opponents" />
            <ContentWrapper>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg">Opponents</h2>
                    <Link href={`/admin/opponents/add`} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Opponent</Link>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th className={clsx([thClasses, 'text-left'])}>Name</th>
                            <th className={clsx([thClasses, 'text-right'])}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {opponents.map((opponent) => (
                            <tr key={opponent.id}>
                                <td className={tdClasses}>{opponent.name}</td>
                                <td className={tdClasses}>
                                    <div className="flex justify-end">

                                        <Link href={`/admin/opponents/${opponent.id}`} className="text-indigo-600 hover:text-indigo-800">
                                            Edit
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ContentWrapper>
        </App >
    )
}